import Alert from 'react-bootstrap/Alert';
import Container from 'react-bootstrap/esm/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar';
import Button from 'react-bootstrap/esm/Button';

import SignaturePad from 'react-signature-pad';
import { useContext, useEffect, useRef, useState } from 'react';
import { DataDispatch, ViewsDispatch } from '../App';
import { countries, nationalites, parishes } from '../data';
import { FetchRequest, TBD } from './common';
import { Context } from '../context';
import uuid from 'uuid';

import { Storage } from 'aws-amplify';
import { Link } from 'react-router-dom';

function invalidEmail(email){
  return(!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/));
}
function PageHeader (){
  return(  <div style={{display : "flex" , justifyContent : "space-between" , marginBottom : 16}}>
            <img alt="AAB" src="AABLogo.png" className="mb-1 aab-logo" style={{marginRight : 8}} width={100}/>
            <img src="pumalogo.png" alt="puma" width={100} className="mb-3 puma-logo"/>
          </div>)
}
function Club() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(DataDispatch,);
  const {state: { clubs },} = useContext(Context);
  const handleFileChange = (changeEvent)=>{
    const file = changeEvent.target.files[0];
    if(!file){
      return;
    }
    if(file.size > (240 * 1024)){
      changeEvent.target.value = null
      dispatch({
        type: 'has_error',
        error_message: 'Photo exceeds maximum allowed size (240 kb).',
        value: true,
      });
      setTimeout(()=>{
        dispatch({
          type: 'has_error',
          error_message: '',
          value: false,
        });
      },2000)
      return
    }
    dispatch({ type: 'photo_file', value: file })
    const fr = new FileReader();
    fr.readAsDataURL  (file)
    fr.onloadend = async (loadEvent)=>{
      const {result} = loadEvent.target
      try{
        const headers = {
          'x-api-key': process.env.REACT_APP_BACKEND_photo_validator_api_key,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        };
        const body = { "photo_data" :  result }
        const { data } = await FetchRequest(process.env.REACT_APP_BACKEND_photo_validator_url,'POST',headers,JSON.stringify(body));
        if(!data || (data.length !== 1)){
          changeEvent.target.value = null
         console.error({email : state.email,error : "Photo is not a headshot."})
         throw new Error("Photo does not match passport style requirements")
        }
        const {BoundingBox} = data[0];
        if(!BoundingBox){
          changeEvent.target.value = null
         console.error({email : state.email,error : "Invalid data parsed from photo."})
         throw new Error("Photo does not match passport style requirements")
        }
        if(BoundingBox.Height < 0.5){
          changeEvent.target.value = null
          console.error({email : state.email,error : "Photo is not a headshot." , BoundingBox})
         throw new Error("Photo does not match passport style requirements")
        }
        dispatch({ type: 'photo_url', value: result })
      }
      catch(err){
        changeEvent.target.value = null
        dispatch({
          type: 'has_error',
          error_message: err.message,
          value: true,
        });
        setTimeout(()=>{
          dispatch({
            type: 'has_error',
            error_message: '',
            value: false,
          });
        },2000)
      }
    }
  }
  return (
    <div>
      <PageHeader/>
      <h2 className="section-header">School/Club</h2>
      <p>Please indicate both school and club if you compete under both</p>
      <div className="border border-bottom" />
      <Form>
        <Form.Group>
          <Form.Text>13. Please Indicate Your School</Form.Text>
          <Row>
            <Col>
              <Form.Control
                as="select"
                onChange={e =>
                  dispatch({ type: 'schoolID', value: e.target.value })
                }
              >
                <option value="not attached" label="-- Please Select --">-- Please Select --</option>
                {
                  clubs.filter((club)=>  club.organization_type === "school").map(club => (
                    <option key={club.id} label={club.name} value={club.id}>{club.name}</option>
                  ))
                }
              </Form.Control>
            </Col>
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group>
          <Form.Text>14. Please Indicate Your Club</Form.Text>
          <Row>
            <Col>
              <Form.Control
                as="select"
                onChange={e => {
                  dispatch({ type: 'clubID', value: e.target.value });
                }}
              >
                <option label="-- Please Select --" value="not attached">
                  -- Please Select --
                </option>
                { clubs.filter((club)=>  club.organization_type === "club").map(club => (
                    <option key={club.id} label={club.name} value={club.id}>{club.name}</option>
                  ))}
              </Form.Control>
            </Col>
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group>
          <Form.Text>
            15. Email Address of Person Who Will Collect And/Or Submit This
            Registration{' '}
          </Form.Text>
          <Form.Text>
            Please insert the email address of either the coach, the person
            authorized to complete athlete registrations, or the athlete if
            independent and over age 18
          </Form.Text>
          <Row>
            <Col>
              <Form.Control
                style={{ width: 300 }} className="form-input"
                type="email"
                value={state.alt_email}
                onChange={e =>
                  dispatch({ type: 'alt_email', value: e.target.value })
                }
              />
            </Col>
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group>
          <Form.Text>
            16. Upload a current passport style photo of athlete (Max size 240 KB) Allowable file types: png, gif, jpg, jpeg{' '} <p className="mb-0 text-danger d-inline">*</p>{' '}
          </Form.Text>
          <Row>
            <Col>
              <input type="File" onChange={handleFileChange} accept="image/gif , image/jpg, image/jpeg, image/png"/>
            </Col>
          </Row>
        </Form.Group>
      </Form>
    </div>
  );
}
function Medical() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(DataDispatch,);
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Medical Attention/Treatment</h2>
      <div className="border border-bottom" />
      <Form>
        <Form.Group className="ml-auto mr-auto">
          <Form.Text>
            17. Please indicate any medical condition for which you are
            presently consulting, or may have consulted a medical practitioner
            within the past 90 days.
          </Form.Text>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>1</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medical_treatment1}  onChange={(e)=> dispatch({ type: 'medical_treatment1', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>2</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medical_treatment2}  onChange={(e)=> dispatch({ type: 'medical_treatment2', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>3</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medical_treatment3}  onChange={(e)=> dispatch({ type: 'medical_treatment3', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>4</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medical_treatment4}  onChange={(e)=> dispatch({ type: 'medical_treatment4', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>5</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medical_treatment5}  onChange={(e)=> dispatch({ type: 'medical_treatment5', value: e.target.value })}/></Col>
          </Row>
        </Form.Group>
      </Form>
      <div className="border border-bottom" />
    </div>
  );
}
function Medication() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(DataDispatch,);
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Medication</h2>
      <div className="border border-bottom" />
      <Form>
        <Form.Group className="ml-auto mr-auto">
          <Form.Text>
            18. Please indicate any prescribed medication which you are
            presently taking, or may have taken within the past 90 days..
          </Form.Text>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>1</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medications1} onChange={(e)=> dispatch({ type: 'medications1', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>2</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medications2} onChange={(e)=> dispatch({ type: 'medications2', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>3</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medications3} onChange={(e)=> dispatch({ type: 'medications3', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>4</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medications4} onChange={(e)=> dispatch({ type: 'medications4', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>5</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.medications5} onChange={(e)=> dispatch({ type: 'medications5', value: e.target.value })}/></Col>
          </Row>
        </Form.Group>
      </Form>
      <div className="border border-bottom" />
    </div>
  );
}
function Supplements() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(DataDispatch,);
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Supplements</h2>
      <div className="border border-bottom" />
      <Form>
        <Form.Group className="ml-auto mr-auto">
          <Form.Text>
            19. Please indicate any supplement(s) or over-the-counter
            medications which you are presently taking, or may have taken within
            the past 90 days
          </Form.Text>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>1</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.supplements1} onChange={(e)=> dispatch({ type: 'supplements1', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>2</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.supplements2} onChange={(e)=> dispatch({ type: 'supplements2', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>3</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.supplements3} onChange={(e)=> dispatch({ type: 'supplements3', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>4</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.supplements4} onChange={(e)=> dispatch({ type: 'supplements4', value: e.target.value })}/></Col>
          </Row>
          <Row className="mb-1">
            <Col style={{display : "flex" , alignItems : "center"}}>
              <p style={{marginBottom : 0 , marginRight : 8}}>5</p>
              <Form.Control style={{ width: 300 }} className="form-input" type="text" value={state.supplements5} onChange={(e)=> dispatch({ type: 'supplements5', value: e.target.value })}/></Col>
          </Row>
        </Form.Group>
      </Form>
      <div className="border border-bottom" />
    </div>
  );
}
function Uniforms() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(
    DataDispatch,
  );
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Uniforms</h2>
      <div className="border border-bottom" />
      <Form>
        <Form.Group>
          <Form.Text>20. Shirt Size</Form.Text>
          <Row className="flex-column ml-0">
            <Form.Check
              className="mr-2"
              type="radio"
              label="XS"
              checked={state.shirt_size === 'XS'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'XS' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="S"
              checked={state.shirt_size === 'S'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'S' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="M"
              checked={state.shirt_size === 'M'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'M' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="L"
              checked={state.shirt_size === 'L'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'L' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XL"
              checked={state.shirt_size === 'XL'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'XL' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XXL"
              checked={state.shirt_size === 'XXL'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'XXL' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XXXL"
              checked={state.shirt_size === 'XXXL'}
              onChange={() => dispatch({ type: 'shirt_size', value: 'XXXL' })}
            />
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group>
          <Form.Text>21. Pants Size</Form.Text>
          <Row className="flex-column ml-0">
            <Form.Check
              className="mr-2"
              type="radio"
              label="XS"
              checked={state.pants_size === 'XS'}
              onChange={() => dispatch({ type: 'pants_size', value: 'XS' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="S"
              checked={state.pants_size === 'S'}
              onChange={() => dispatch({ type: 'pants_size', value: 'S' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="M"
              checked={state.pants_size === 'M'}
              onChange={() => dispatch({ type: 'pants_size', value: 'M' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="L"
              checked={state.pants_size === 'L'}
              onChange={() => dispatch({ type: 'pants_size', value: 'L' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XL"
              checked={state.pants_size === 'XL'}
              onChange={() => dispatch({ type: 'pants_size', value: 'XL' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XXL"
              checked={state.pants_size === 'XXL'}
              onChange={() => dispatch({ type: 'pants_size', value: 'XXL' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="XXXL"
              checked={state.pants_size === 'XXXL'}
              onChange={() => dispatch({ type: 'pants_size', value: 'XXXL' })}
            />
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group>
          <Form.Text>22. Shoe Size (US)</Form.Text>
          <Row className="flex-column ml-0">
            <Form.Check
              className="mr-2"
              type="radio"
              label="6.5"
              checked={state.shoe_size === '6.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '6.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="7.0"
              checked={state.shoe_size === '7.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '7.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="7.5"
              checked={state.shoe_size === '7.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '7.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="8.0"
              checked={state.shoe_size === '8.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '8.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="8.5"
              checked={state.shoe_size === '8.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '8.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="9.0"
              checked={state.shoe_size === '9.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '9.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="9.5"
              checked={state.shoe_size === '9.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '9.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="10.0"
              checked={state.shoe_size === '10.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '10.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="10.5"
              checked={state.shoe_size === '10.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '10.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="11.0"
              checked={state.shoe_size === '11.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '11.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="11.5"
              checked={state.shoe_size === '11.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '11.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="12.0"
              checked={state.shoe_size === '12.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '12.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="12.5"
              checked={state.shoe_size === '12.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '12.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="13.0"
              checked={state.shoe_size === '13.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '13.0' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="13.5"
              checked={state.shoe_size === '13.5'}
              onChange={() => dispatch({ type: 'shoe_size', value: '13.5' })}
            />
            <Form.Check
              className="mr-2"
              type="radio"
              label="14.0"
              checked={state.shoe_size === '14.0'}
              onChange={() => dispatch({ type: 'shoe_size', value: '14.0' })}
            />
          </Row>
        </Form.Group>
        <div className="border border-bottom" />
      </Form>
    </div>
  );
}
function Consent() {
  const { dataDispacth: dispatch, _dataState: state } = useContext(
    DataDispatch,
  );
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Consent Form</h2>
      <ol>
        <strong>
          <li>
            The applicant or (parent/guardian if athlete is under age 18) and
            the authorised club/school representative must sign this form.
          </li>
        </strong>
        <strong>
          <li>
            The rules of the AAB require a 90 day competition waiting period
            before a change in affilation can be permitted.
          </li>
        </strong>
        <strong>
          <li>
            Annual Registration fees are due no later than January 31st, payment
            thereafter shall incure late fees as published by the AAB.
          </li>
        </strong>
      </ol>
      <strong>
        The annual registration fees for club/school athlete - $10.00;
        Independent athlete - $25.00
      </strong>
      <Form>
        <Form.Group style={{ position: 'relative' }}>
          <Form.Text style={{textAlign : "justify"}}>
            23. WAIVER: In consideration of the acceptance of my application for
            membership, I/My Executors and Administrators, HEREBY RELEASE and
            DISCHARGE the Athletics Association of Barbados Inc. (AAB) and its
            respective agents of and from all claims, demands, damages, costs
            and expenses arising by reason of my registration with the AAB or my
            participation in any AAB sponsored or sanctioned events. I agree to
            abide by all rules, procedures and policies of the Athletics
            Association of Barbados Inc. and World Athletics. Signature of Applicant/Guardian (if
            applicant is under age 18) State relation to registrant next to name
          </Form.Text>
          {TBD && <SignaturePad clearButton="true" />}
          <div className="mt-2">
            <div style={{display : "flex" ,flexDirection : "column" , justifyContent : "center" }}>
              <Form.Control
              placeholder="Enter Signature"
              style={ state.has_error ? { ...styles.error, width: 300 } : { width: 300 } }
              type="text"
              value={state.sig_waiver}
              onChange={e => dispatch({ type: 'sig_waiver', value: e.target.value }) }
            />
            <Col style={{display : "flex", alignItems : 'flex-start', marginTop : 4, paddingLeft :0}}>
            <label className="custom-checkbox">
              <input type="checkbox"  onChange={(e)=>dispatch({type : "sig_check_waiver", value : e.target.checked})}/>
              <span/>
            </label>
              <Form.Text className="mt-0 ml-1 text-muted">By clicking this checkbox, you agree that you have read the above terms and accept that entering your name into the represents your signature</Form.Text>
            </Col>
            </div>
          </div>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group style={{ position: 'relative' }}>
          <Form.Text style={{textAlign : "justify"}}>
            24. In accordance with the World Athletics and World Anti-Doping regulation I
            hereby agree to submit to anti-doping testing (In -competition and
            out -of competition) conducted or authorised by the AAB . Signature
            of Applicant/Guardian (if applicant is under age 18) State relation
            to registrant next to name
          </Form.Text>
          {TBD && <SignaturePad clearButton="true" />}
          <div className="mt-2">
            <div style={{display : "flex" ,flexDirection : "column" , justifyContent : "center" , alignItems : 'flex-start', marginTop : 4}}>
              <Form.Control
              placeholder="Enter Signature"
              style={
                state.has_error
                  ? { ...styles.error, width: 300 }
                  : { width: 300 }
              }
              type="text"
              value={state.sig_antidope}
              onChange={e =>
                dispatch({ type: 'sig_antidope', value: e.target.value })
              }
            />
            <Col style={{display : "flex", alignItems : 'flex-start', marginTop : 4, paddingLeft :0}}>
            <label className="custom-checkbox">
              <input type="checkbox"  onChange={(e)=>dispatch({type : "sig_check_antidope", value : e.target.checked})}/>
              <span/>
            </label>
              <Form.Text className="mt-0 ml-1 text-muted">By clicking this checkbox, you agree that you have read the above terms and accept that entering your name into the represents your signature</Form.Text>
            </Col>
            </div>
          </div>
        </Form.Group>
        <div className="border border-bottom" />
        <Form.Group style={{ position: 'relative' }}>
          <Form.Text style={{textAlign : "justify"}}>
            25. The AAB permits dual registration with a club and school, in the
            case of dual entries. I/legal guardian (for athlete under age 18)
            give the authority for entries and participation to the school and
            club listed as per this registration. Signature of
            Applicant/Guardian (if applicant is under age 18) State relation to
            registrant next to name.
          </Form.Text>
          {TBD && <SignaturePad clearButton="true" />}
          <div className="mt-2">
            <div style={{display : "flex" ,flexDirection : "column" , justifyContent : "center" , alignItems : 'flex-start', marginTop : 4}}>
              <Form.Control
              placeholder="Enter Signature"
              style={
                state.has_error
                  ? { ...styles.error, width: 300 }
                  : { width: 300 }
              }
              type="text"
              value={state.sig_authorize}
              onChange={e =>
                dispatch({ type: 'sig_authorize', value: e.target.value })
              }
            />
            <Col style={{display : "flex", alignItems : 'flex-start', marginTop : 4, paddingLeft :0}}>
            <label className="custom-checkbox">
              <input type="checkbox"  onChange={(e)=>dispatch({type : "sig_check_authorize", value : e.target.checked})}/>
              <span/>
            </label>
              <Form.Text className="mt-0 ml-1 text-muted">By clicking this checkbox, you agree that you have read the above terms and accept that entering your name into the represents your signature</Form.Text>
            </Col>
            </div>
          </div>
        </Form.Group>
        <div className="border border-bottom" />
      </Form>
    </div>
  );
}
function Submit() {
  return (
    <div style={{ minHeight: 600 }}>
      <PageHeader/>
      <h2 className="section-header">Successful Completion</h2>
      <div className="border border-bottom" />
      <p>
        This confirms the successful completion of your registration form. Please note that a
        parent or legal guardian is required to give consent to your participation
        if you are under age 18 at the date of completion.
      </p>
      <p>The Athletic Association of Barbados</p>
    </div>
  );
}
function End() {
  return <div style={{ minHeight: 600 }}>
          <PageHeader/>
          <h4>Form Submitted</h4>
          <p>Your application has been submitted to the Athletics Association of Barbados. Please check your email for confirmation.</p>
        </div>;
}
function Athlete() {
  const [currentPage, setCurrentPage] = useState(0);
  const viewDispatch = useContext(ViewsDispatch);
  const {state: { clubs },} = useContext(Context);
  const { _dataState: state, dataDispacth: dispatch } = useContext(
    DataDispatch,
  );
  const { getClubs } = useContext(Context);
  const { addAthlete } = useContext(Context);
  const { athleteEmailExists , coachEmailExists} = useContext(Context);
  const [duplicate , setDuplicate] = useState(false);
  const [isSubmitting ,setIsSubmitting] = useState(false);

  function Profile() {
    useEffect(()=>{
      if(invalidEmail(state.email)){
        setDuplicate(false);
        return;
      }
      isDuplicateEmail();
    },[state.email]);
  
    async function isDuplicateEmail(){
      try{
        let items = await athleteEmailExists(state.email);
        if(items.length !== 0){
          setDuplicate(true);
          return;
        } 
        items = await coachEmailExists(state.email);
        if(items.length !== 0){
          setDuplicate(true);
          return;
        }
        setDuplicate(false);
      }
      catch(err){
        console.log(err);
      }
    }
  
    let dateRef = useRef();
    const handleEmailChange = (e)=>{
      dispatch({ type: 'email', value: e.target.value })
    }
    const handleBlur = ()=>{
      const { email } = state;
      let storedState = localStorage.getItem(email);
      if(!storedState){
        return;
      }
      try{
        storedState = JSON.parse(storedState);
      }
      catch(err){
        console.log(err);
        return
      }
      dispatch({ type: 'LOAD_SAVED_STATE', value: storedState })
    }
    const handleNridChange = e => {
      const value = e.target.value;
      if (value && !value.match('^[0-9]+$')) {
        return;
      }
      dispatch({ type: 'nrid', value });
    };
    const handleHomeChange = e => {
      const value = e.target.value;
      if (value && !value.match('^[0-9]+$')) {
        return;
      }
      dispatch({ type: 'home', value });
    };
    const handleMobileChange = e => {
      const value = e.target.value;
      if (value && !value.match('^[0-9]+$')) {
        return;
      }
      dispatch({ type: 'mobile', value });
    };
    const handleInsuraceFileChange = (e)=>{
      const file = e.target.files[0];
      if(!file){
        return;
      }
      if(file.size > (240 * 1024)){
        e.target.value = null
        dispatch({
          type: 'has_error',
          error_message: 'Document exceeds maximum allowed size (240 kb).',
          value: true,
        });
        setTimeout(()=>{
          dispatch({
            type: 'has_error',
            error_message: '',
            value: false,
          });
        },2000)
        return
      }
      dispatch({ type: 'supporting_file', value: file })
      const fr = new FileReader();
      fr.readAsDataURL(file)
      fr.onloadend = async (e)=>{
        const {result} = e.target
        dispatch({ type: 'waiver_url', value: result })
      }
    }
    return (
      <div style={{ minHeight: 600 }}>
        <PageHeader/>
        {state.has_error && ( <Alert show variant="danger">{state.error_message}</Alert> )}
        <h2 className="section-header">Athlete Profile & Contact Information</h2>
        <div className="border border-bottom" />
        <Form>
          <Form.Group>
            <Form.Text>
              1. Email Address <p className="mb-0 text-danger d-inline">*</p>
            </Form.Text>
            <Row>
              <Col>
                <Form.Control
                className="form-input mb-2"
                  style={
                    (!state.email || invalidEmail(state.email))  && state.has_error
                      ? { ...styles.error, width: 300 }
                      : { width: 300 }
                  }
                  type="email"
                  required
                  onChange={handleEmailChange}
                  onBlur={handleBlur}
                  value={state.email}
                />
                {(state.email_error || duplicate) && (
                  <Alert show variant="danger" className="mb-1">
                    {state.email_error && state.email_errormsg}
                    {duplicate && "Email previously registered"}
                  </Alert>
                )}
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              2. NAME ( Please provide first, middle and surname){' '}
              <p className="mb-0 text-danger d-inline">*</p>
            </Form.Text>
            <Row className="info-row">
              <Col className="info-input">
                <Form.Control
                  style={
                    !state.first_name && state.has_error ? styles.error : null
                  }
                  type="text"
                  placeholder="First name"
                  required
                  onChange={e =>
                    dispatch({ type: 'first_name', value: e.target.value })
                  }
                  value={state.first_name}
                />
              </Col>
              <Col className="info-input">
                <Form.Control
                  placeholder="Middle Name"
                  onChange={e =>
                    dispatch({ type: 'middle_name', value: e.target.value })
                  }
                  value={state.middle_name}
                />
              </Col>
              <Col className="info-input">
                <Form.Control
                  style={
                    !state.last_name && state.has_error ? styles.error : null
                  }
                  placeholder="Surname"
                  required
                  onChange={e =>
                    dispatch({ type: 'last_name', value: e.target.value })
                  }
                  value={state.last_name}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>3. Address (Apt/House Number, Street Address)</Form.Text>
            <Form.Control
              placeholder="Enter address..."
              onChange={e => dispatch({ type: 'address', value: e.target.value })}
              value={state.address}
            />
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>4. Parish</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }} className="form-input"
                  as="select"
                  value={state.parish}
                  onChange={e =>
                    dispatch({ type: 'parish', value: e.target.value })
                  }
                >
                  <option value="">--- Select Parish ---</option>
                  {parishes.map((parish, index) => (
                    <option value={parish} key={index}>
                      {parish}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>5. Date of Birth</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }} className="form-input"
                  type="date"
                  required
                  ref={ref => (dateRef = ref)}
                  onChange={() => dispatch({ type: 'dob', value: dateRef.value })}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              6. National Registration No.{' '}
              <p className="mb-0 text-danger d-inline">*</p>
            </Form.Text>
            <Form.Text>E.g. 2011230038</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  id="nrid"
                  className="form-input"
                  style={(!state.nrid || state.nrid.length !== 10) && state.has_error? { ...styles.error, width: 300 }: { width: 300 }}
                  type="text"
                  required
                  onChange={handleNridChange}
                  value={state.nrid}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              7. Gender <p className="mb-0 text-danger d-inline">*</p>
            </Form.Text>
            <Row>
              <Col style={!state.gender && state.has_error ? styles.error : null}>
                <Form.Check
                  type="radio"
                  label="Male"
                  required
                  checked={state.gender === 'Male'}
                  onChange={() => dispatch({ type: 'gender', value: 'Male' })}
                />
                <Form.Check
                  type="radio"
                  label="Female"
                  required
                  checked={state.gender === 'Female'}
                  onChange={() => dispatch({ type: 'gender', value: 'Female' })}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>8. Country of Birth</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  as="select"
                  value={state.country}
                  onChange={e =>
                    dispatch({ type: 'country', value: e.target.value })
                  }
                >
                  <option value="">--- Select Country ---</option>
                  {countries.map((country, index) => (
                    <option key={index} value={country}>
                      {country}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>9. Nationality</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  as="select"
                  value={state.nationality}
                  onChange={e =>
                    dispatch({ type: 'nationality', value: e.target.value })
                  }
                >
                  <option value="">--- Select Nationality ---</option>
                  {nationalites.map((nationality, index) => (
                    <option key={index} value={nationality}>
                      {nationality}
                    </option>
                  ))}
                </Form.Control>
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>10. Home (e.g. 5433210)</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }} className="form-input"
                  type="tel"
                  onChange={handleHomeChange}
                  value={state.home}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>11. Mobile (e.g. 5433210)</Form.Text>
            <Row>
              <Col>
                <Form.Control
                  style={{ width: 300 }} className="form-input"
                  type="tel"
                  onChange={handleMobileChange}
                  value={state.mobile}
                />
              </Col>
            </Row>
          </Form.Group>
          <div className="border border-bottom" />
          <Form.Group>
            <Form.Text>
              12. Are you registering for group medical insurance coverage?
            </Form.Text>
            <Row>
              <Col>
                <Form.Check
                  type="radio"
                  label="Yes"
                  onChange={() => dispatch({ type: 'medical', value: true  })}
                  checked={state.medical}
                />
                <Form.Check
                  type="radio"
                  label="No"
                  onChange={() => dispatch({ type: 'medical', value: false })}
                  checked={!state.medical}
                />
              </Col>
            </Row>
            {
                !state.medical &&
                <>
                  <Form.Text>
                    12b . Upload a signed copy of <a href={process.env.REACT_APP_WAIVER_URL}>this waiver</a>&nbsp; or supporting documentation as evidence of alternative medical insurance.
                  </Form.Text>
                  <Row>
                  <Col>
                    <input type="File" onChange={handleInsuraceFileChange}/>
                  </Col>
                </Row>
                </>
              }
          </Form.Group>
          <div className="border border-bottom" />
        </Form>
      </div>
    );
  }
  function Review() {
    const { _dataState: state } = useContext(DataDispatch);
    return (
      <div style={{ minHeight: 600 }}>
        <PageHeader/>
        <h2 className="section-header">Registration Review</h2>
        <div className="border border-bottom" />
        <p>Please review your registration form</p>
        <div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Profile & Contact Information</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(0)}>Edit</Button>
            </div>
            <div>
              <p className={`text-${(invalidEmail(state.email) || duplicate) ? "danger" : "muted"}`}>1. Email Address</p>
              {state.email && (
                <ul>
                  <li>
                    <span className={`text-${duplicate ? "danger" : "muted"}`}>{`${state.email}`}</span>
                    { duplicate && <em className={`text-danger ml-5`} style={{fontSize : 12}}>{`Email previously registered`}</em>}
                  </li>
                </ul>
              )}
              <div>
                <p>2. Name</p>
                <ul>
                  <li className={`text-${!state.first_name ? "danger" : "muted"}`}>{`First Name : ${state.first_name}`}</li>
                  <li className={`text-muted`}>{`Middle Name : ${state.middle_name}`}</li>
                  <li className={`text-${!state.last_name ? "danger" : "muted"}`}>{`Surname : ${state.last_name}`}</li>
                </ul>
              </div>
            </div>
            <p>3. Address</p>
            {state.address && (
              <ul>
                <li className="text-muted">{`${state.address}`}</li>
              </ul>
            )}
            <p>4. Parish</p>
            {state.parish && (
              <ul>
                <li className="text-muted">{`${state.parish}`}</li>
              </ul>
            )}
            <p>5. Date of Birth</p>
            {state.dob && (
              <ul>
                <li className="text-muted">{`${state.dob}`}</li>
              </ul>
            )}
            <p className={`text-${(!state.nrid || state.nrid.length !== 10) ? "danger" : "muted"}`}>6. National Registration No.</p>
            {state.nrid && (
              <ul>
              <li className={`text-${(!state.nrid || state.nrid.length !== 10) ? "danger" : "muted"}`}>{`National Registration No. : ${state.nrid}`}</li>
              </ul>
            )}
            <p className={`text-${!state.gender ? "danger" : "muted"}`}>7. Gender</p>
            {state.gender && (
              <ul>
                <li className="text-muted">{`${state.gender}`}</li>
              </ul>
            )}
            <p>8. Country of Birth</p>
            {state.country && (
              <ul>
                <li className="text-muted">{`${state.country}`}</li>
              </ul>
            )}
            <p>9. Nationality</p>
            {state.nationality && (
              <ul>
                <li className="text-muted">{`${state.nationality}`}</li>
              </ul>
            )}
            <p>10. Home</p>
            {state.home && (
              <ul>
                <li className="text-muted">{`${state.home}`}</li>
              </ul>
            )}
            <p>11. Mobile</p>
            {state.mobile && (
              <ul>
                <li className="text-muted">{`${state.mobile}`}</li>
              </ul>
            )}
            <p>12. Are you registering for group medical insurance coverage?</p>
            <ul>
              <li className="text-muted">{`${state.medical ? 'Yes' : 'No'}`}</li>
            </ul>
            {
              !state.medical &&  state.waiver_url && (
                <ul>
                   <li><a href={state.waiver_url} target="_blank" rel="noreferrer" >Waiver or supporting document.</a></li>
                </ul>
              )}
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">School / Club</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(1)}>Edit</Button>
            </div>
            <p>13. Please Indicate Your School</p>
            {clubs.filter((club)=>club.id === state.schoolID)[0]?.name && (
              <ul>
                <li className="text-muted">{`${clubs.filter((club)=>club.id === state.schoolID)[0]?.name}`}</li>
              </ul>
            )}
            <p>14. Please Indicate Your Club</p>
            {clubs.filter((club)=>club.id === state.clubID)[0]?.name && (
              <ul>
                <li className="text-muted">{`${clubs.filter((club)=>club.id === state.clubID)[0]?.name}`}</li>
              </ul>
            )}
            <p>
              15. Email Address of Person Who Will Collect And/Or Submit This
              Registration{' '}
            </p>
            {state.alt_email && (
              <ul>
                <li className="text-muted">{`${state.alt_email}`}</li>
              </ul>
            )}
            <p>16. Upload a current passport style photo of athlete.</p>
            {state.photo_url && (
              <ul>
                <img src={state.photo_url}  height={150} alt=""/>
              </ul>
            )}
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Medical Treatment</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(2)}>Edit</Button>
            </div>
            <p>
              17. Please indicate any medical condition for which you are
              presently consulting, or may have consulted a medical practitioner
              within the past 90 days.
            </p>
              <ol>
                <li>{state.medical_treatment1}</li>
                <li>{state.medical_treatment2}</li>
                <li>{state.medical_treatment3}</li>
                <li>{state.medical_treatment4}</li>
                <li>{state.medical_treatment5}</li>
              </ol>
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Medication</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(3)}>Edit</Button>
            </div>
            <p>
              18. Please indicate any prescribed medication which you are
              presently taking, or may have taken within the past 90 days..
            </p>
              <ol>
                <li>{state.medications1}</li>
                <li>{state.medications2}</li>
                <li>{state.medications3}</li>
                <li>{state.medications4}</li>
                <li>{state.medications5}</li>
              </ol>
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Supplements</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(4)}>Edit</Button>
            </div>
            <p>
              19. Please indicate any supplement(s) or over-the-counter
              medications which you are presently taking, or may have taken within
              the past 90 days
            </p>
              <ol>
                <li>{state.supplement1}</li>
                <li>{state.supplement2}</li>
                <li>{state.supplement3}</li>
                <li>{state.supplement4}</li>
                <li>{state.supplement5}</li>
              </ol>
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Uniforms</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(5)}>Edit</Button>
            </div>
            <p>20. Shirt Size</p>
            <ul>
              { state.shirt_size && <li className="text-muted">{`${state.shirt_size}`}</li>}
            </ul>
            <p>21. Pants Size</p>
            <ul>
              { state.pants_size && <li className="text-muted">{`${state.pants_size}`}</li>}
            </ul>
            <p>22. Shoe Size (US)</p>
            <ul>
              {state.shoe_size && <li className="text-muted">{`${state.shoe_size}`}</li>}
            </ul>
          </div>
          <div>
            <div  style={{display : "flex" , justifyContent : "space-between", paddingBottom : 2 , marginBottom : 2, borderBottom : "2px solid #dee2e6"}}>
              <h2 className="review-section-name">Consent Forms</h2>
              <Button variant="light" size="sm" onClick={()=>gotoPage(6)}>Edit</Button>
            </div>
            <p style={{textAlign : "justify"}} className={`text-${!state.sig_waiver ? "danger" : "muted"}`}>23. WAIVER.</p>
            <ul>
              <li className="text-muted">{`Signature of : ${state.sig_waiver}`}</li>
            </ul>
            <p style={{textAlign : "justify"}} className={`text-${!state.sig_antidope ? "danger" : "muted"}`}>24.World Anti-Doping regulation.</p>
            <ul>
              <li className="text-muted">{`Signature of : ${state.sig_antidope}`}</li>
            </ul>
            <p style={{textAlign : "justify"}} className={`text-${!state.sig_authorize ? "danger" : "muted"}`}>25. AAB permission.</p>
            <ul>
              <li className="text-muted">{`Signature of : ${state.sig_authorize}`}</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }
  useEffect(() => {
    getClubs();
  }, []);
  const sections = [
    Profile(),
    <Club />,
    <Medical />,
    <Medication />,
    <Supplements />,
    <Uniforms />,
    <Consent />,
    <Review />,
    <Submit />,
    <End />,
  ].filter(e => e);
  const progresses = [
    9,
    18,
    27,
    36,
    45,
    54,
    64,
    73,
    91,
    100,
  ].filter(e => e);
  const gotoNext = function () {
    const {
      first_name,
      last_name,
      nrid,
      gender,
      email,
      sig_antidope,
      sig_authorize,
      sig_waiver,
      sig_check_antidope,
      sig_check_authorize,
      sig_check_waiver,
    } = state;
    if (currentPage === 0 &&(!first_name || !last_name || !nrid || !gender || !email)) {
      dispatch({
        type: 'has_error',
        error_message: 'Required values are missing!!',
        value: true,
      });
      return;
    }
    if ((currentPage === 6 ) && (!sig_check_waiver || !sig_waiver || !sig_check_antidope || !sig_antidope || !sig_authorize || !sig_check_authorize)) {
      dispatch({
        type: 'has_error',
        error_message: 'All Terms must be accepted!!',
        value: true,
      });
      return;
    }
    if (currentPage === 7 &&(!first_name || !last_name || !nrid || !gender || !email || duplicate || !sig_check_waiver || !sig_waiver || !sig_check_antidope || !sig_antidope || !sig_authorize || !sig_check_authorize)) {
      dispatch({
        type: 'has_error',
        error_message: 'Please review information highlighted!!',
        value: true,
      });
      return;
    }
    if (invalidEmail(email)) {
      dispatch({
        type: 'has_error',
        error_message: 'Invalid email address',
        value: true,
      });
      return;
    }
    if (nrid.length !== 10) {
      dispatch({
        type: 'has_error',
        error_message: 'invalid nrid format',
        value: true,
      });
      return;
    }
    dispatch({ type: 'has_error', error_message: '', value: false });
    setTimeout(() => {
      viewDispatch({ value: 'athlete' });
      setCurrentPage(currentPage + 1);
    });
  };
  const gotoPrev = function () {
    setTimeout(() => {
      viewDispatch({ value: 'athlete' });
      setCurrentPage(currentPage - 1);
    });
  };
  const gotoPage = function(page){
    setTimeout(() => {
      viewDispatch({ value: 'athlete' });
      setCurrentPage(page);
    });
  }
  const handleSaveDraft = function(){
    const { email } = state;
    if(!email ||  invalidEmail(email)){
      return alert("A valid email must be entered")
    }
    if(duplicate){
      return alert("Email previously registered and cannot be used for new registration")
    }
    dispatch({type: 'has_error',error_message: '',value: false});
    localStorage.setItem(email,JSON.stringify(state))
    alert("Information saved")
  }
  const handleFormSubmit = async function () {
    setIsSubmitting(true);
    try {
      const atheleteState = state;

      delete atheleteState['has_error'];
      delete atheleteState['submit_error'];
      delete atheleteState['sig_check_waiver'];
      delete atheleteState['sig_check_authorize'];
      delete atheleteState['sig_check_antidope'];
      delete atheleteState['error_message'];

      const d = new Date().getFullYear() % 2000;
      atheleteState.id = 'AAB-' + String(d) + uuid.v4().split('-')[4].slice(0,4).toUpperCase();;

      if(atheleteState.photo_file){
        const r = await Storage.put(atheleteState.id , atheleteState.photo_file ,{
          contentTpe : atheleteState.photo_file.type
        })
        atheleteState.photo_url = r.key;
      }
      if(atheleteState.supporting_file){
        const r2 = await Storage.put("waiver_" + atheleteState.id  + "_" + atheleteState.supporting_file.name, atheleteState.supporting_file ,{
          contentTpe : atheleteState.supporting_file.type
        })
        atheleteState.waiver_url = r2.key;
      }
      delete atheleteState['photo_file'];
      delete atheleteState['supporting_file'];
      await addAthlete(atheleteState);
      localStorage.removeItem(state.email)
      gotoNext();
    } catch (err) {
      if(err.errors){
        const { message , path } = err.errors[0];
        console.error(JSON.stringify({message , path , email : state.email}));
      }
      else{
        console.error(JSON.stringify({email : state.email , error:err }));
      }
      dispatch({ type: 'submit_error', value: true });
    }
    finally{
      setIsSubmitting(false);
    }
  };
  return (
    <Container
      style={{ minHeight: 400, backgroundColor: 'white' }}
      className="d-flex flex-column"
    >
      <div className="d-flex justify-content-end mt-1"  style={{ width: '100%' }}>
        <Link to="/">
          <Button
            onClick={() => {
              dispatch({type : "RESET_STATE"});
              viewDispatch({ value: 'loading' });
              setTimeout(() => viewDispatch({ value: 'home' }), 1000);
            }}
            variant="light text-muted">
            Cancel
        </Button>
        </Link>
      </div>
      {sections[currentPage]}
      <div className="mt-2 d-flex justify-content-center mb-2">
        {currentPage > 0 && currentPage !== sections.length - 1 && (
          <Button className="mr-2" onClick={gotoPrev}>Back</Button>
        )}
        {currentPage < sections.length - 2 && (
          <Button className="ml-2" onClick={gotoNext}>Next</Button>
        )}
        {currentPage !== sections.length - 2 && (
          <Button className="ml-2 text-muted" variant="light" onClick={handleSaveDraft}>Save as draft</Button>
        )}
        {currentPage < sections.length - 3 && (
          <Button className="ml-2 text-muted" variant="light" onClick={()=>gotoPage(7)}>Review</Button>
        )}
        {currentPage === sections.length - 2 && (
          <Button className="ml-2" variant="success" onClick={handleFormSubmit} disabled={isSubmitting || duplicate || state.has_error}>Submit</Button>
        )}
      </div>
      {currentPage < sections.length - 1 && (
        <ProgressBar
          now={progresses[currentPage]}
          label={`${progresses[currentPage]}%`}
          style={{ width: 200 }}
          className="ml-auto mr-auto mb-2"
        />
      )}
      {(state.submit_error || state.has_error) && (
        <Alert show variant="danger">
          { state.has_error ? state.error_message : "A system error has occured. Please try again. If the issue persists, please contact an adminstator" }
        </Alert>
      )}
    </Container>
  );
}
const styles = {
  error: {
    border: '1px solid red',
  },
};
export default Athlete;
